var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 6,
    viewBox: "0 0 20 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.731875 5.5V0.19H1.78188V4.62H1.82188L3.88188 0.19H5.46188V5.5H4.40188V1.08H4.36188L2.33188 5.5H0.731875ZM7.06977 5.5V0.19H8.87977L10.1098 4.8H10.1698L11.3998 0.19H13.2098V5.5H12.1798V0.9H12.1298L10.8598 5.5H9.41977L8.15977 0.9H8.09977V5.5H7.06977ZM18.1934 5.5V0.19H19.2634V5.5H18.1934ZM14.8334 5.5V0.19H15.9034V5.5H14.8334ZM15.6034 1.07V0.19H18.4734V1.07H15.6034Z",
    fill: "#25CB8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.81585b4be220f3cff8d9d85cea5a472a.svg";
export { ForwardRef as ReactComponent };